import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import VendorRegisterPage from "./pages/VendorLoginPage/VendorRegisterPage";
import VendorDashboard from "./pages/VendorLoginPage/VendorDashboard";
import VendorLogin from "./pages/VendorLoginPage/VendorLogin";
import VendorForgotPassword from "./pages/VendorLoginPage/VendorForgotPassword";
import VendorItems from "./pages/VendorLoginPage/VendorItems";
import VendorProfile from "./pages/VendorLoginPage/VendorProfile";
import VendorAllOrders from "./pages/VendorLoginPage/VendorAllOrders";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/vendor/login" replace />} />
        <Route path="/vendor" element={<Navigate to="/vendor/login" replace />} />
        <Route path="/vendor/login" element={<VendorLogin />} />
        <Route path="/vendor/register" element={<VendorRegisterPage />} />
        <Route path="/vendor/dashboard" element={<VendorDashboard />} />
        <Route path="/vendor/forgot-password" element={<VendorForgotPassword />} />
        <Route path="/vendor/items" element={<VendorItems />} />
        <Route path="/vendor/profile" element={<VendorProfile />} />
        <Route path="/vendor/all-orders" element={<VendorAllOrders />} />
      </Routes>
    </Router>
  );
}

export default App;
